__turbopack_context__.v({
  "active": "pagination-module__PEppuq__active",
  "break": "pagination-module__PEppuq__break",
  "disabled": "pagination-module__PEppuq__disabled",
  "link": "pagination-module__PEppuq__link",
  "next": "pagination-module__PEppuq__next",
  "pagination": "pagination-module__PEppuq__pagination",
  "previous": "pagination-module__PEppuq__previous",
  "selected": "pagination-module__PEppuq__selected",
});
